var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntra = function SvgEntra(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#225086",
    d: "M4.224 15.591c.432.269 1.148.568 1.906.568.69 0 1.331-.2 1.862-.541l.002-.001L10 14.363v4.526c-.318 0-.638-.087-.916-.26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DF",
    d: "m8.726 1.674-8.334 9.4c-.643.727-.475 1.825.36 2.346l3.472 2.171c.432.269 1.148.568 1.906.568.69 0 1.331-.2 1.862-.541l.002-.001L10 14.363l-4.849-3.03 4.85-5.472v-4.75c-.471 0-.942.188-1.275.563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBF8FF",
    d: "m5.151 11.332.058.036L10 14.363h.001v-8.5L10 5.86z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#074793",
    d: "M19.249 13.42c.834-.521 1.002-1.619.359-2.346L14.14 4.907a3.45 3.45 0 0 0-1.459-.324 3.4 3.4 0 0 0-2.558 1.14l-.12.137 4.848 5.471-4.85 3.031v4.526c.319 0 .637-.087.915-.26l8.333-5.21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0294E4",
    d: "M10.001 1.111v4.75l.121-.137a3.4 3.4 0 0 1 2.558-1.14 3.5 3.5 0 0 1 1.459.324l-2.866-3.232A1.7 1.7 0 0 0 10 1.112z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#96BCC2",
    d: "m14.85 11.332-4.849-5.47v8.5z"
  })));
};
export default SvgEntra;